import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  loading: false,
  error: null,
  //sampling
  sampleCoverageData: [],
  districtLoading: false,
  districtError: null,
  districtData: [],
  //compliance
  complianceLoading: false,
  complianceError: null,
  complianceData: null,
};

const sampleCoverageSlice = createSlice({
  name: "sampleCoverage",
  initialState,
  reducers: {
    fetchSampleCoverage: (state, action) => {
      state.loading = true;
      state.error = null;
    },
    fetchSampleCoverageSuccess: (state, action) => {
      state.loading = false;
      state.sampleCoverageData = action.payload?.data || [];
    },
    fetchSampleCoverageFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    fetchDistrictData: (state, action) => {
      state.districtLoading = true;
      state.districtError = null;
    },
    fetchDistrictDataSuccess: (state, action) => {
      state.districtLoading = false;
      state.districtData = action.payload?.data || [];
    },
    fetchDistrictDataFailure: (state, action) => {
      state.districtLoading = false;
      state.districtError = action.payload;
    },
    //compliance
    fetchComplianceData: (state, action) => {
      state.complianceLoading = true;
      state.complianceError = null;
    },
    fetchComplianceDataSuccess: (state, action) => {
      state.complianceLoading = false;
      state.complianceData = action.payload;
    },
    fetchComplianceDataFailure: (state, action) => {
      state.complianceLoading = false;
      state.complianceError = action.payload;
    },
  },
});

export const { actions, reducer } = sampleCoverageSlice;
export const sliceKey = sampleCoverageSlice.name;